export default __webpack_public_path__ + "static/media/toy7.e94861b7.jfif";